import type React from "react";
import { createContext, useContext } from "react";

type ContextValue = {
  activeNewsletterId?: string;
  checkedNewsletterIdsMap?: Record<string, string[]>;
  setActiveNewsletterId: React.Dispatch<React.SetStateAction<string>>;
  setCheckedNewsletterIdsMap: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;
  setIsDisplayMobilePreview: React.Dispatch<React.SetStateAction<boolean>>;
};

export const NewsletterListContext = createContext<ContextValue>({
  setActiveNewsletterId: () => {},
  setCheckedNewsletterIdsMap: () => {},
  setIsDisplayMobilePreview: () => {},
});
export const useNewsletterListContext = () => useContext(NewsletterListContext);
